"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluginSchema = exports.BusinessPluginSchema = exports.ServicePluginSchema = exports.PluginGeneralSchema = exports.PluginReportSchema = exports.CredentialTypeSchema = exports.PluginTypeSchema = void 0;
const zod_1 = require("zod");
const jsonForm_1 = require("../misc/jsonForm");
const token_1 = require("../misc/token");
const BusinessMisc = __importStar(require("../misc/business"));
const ReportMisc = __importStar(require("../misc/report"));
// export const PluginTypeSchema = z.enum(["Ceres Tag", "OptiWeigh", "Angus Australia", "APPG", "Galactica", "Waterwatch", "DigiRodeo"])
exports.PluginTypeSchema = zod_1.z.enum(["DigiRodeo", "Ceres Tag"]);
exports.CredentialTypeSchema = zod_1.z.enum(["byservice", "bybusiness"]);
exports.PluginReportSchema = zod_1.z.object({
    type: zod_1.z.string(),
    outerFilters: zod_1.z.array(ReportMisc.OuterFilterSchema),
    columns: zod_1.z.array(ReportMisc.FilterColumnSchema),
    activityType: zod_1.z.string().optional()
});
exports.PluginGeneralSchema = zod_1.z.object({
    uuid: zod_1.z.string(),
    name: exports.PluginTypeSchema,
    description: zod_1.z.string(),
    status: zod_1.z.enum(["active", "obsolete"]),
    imageUrl: zod_1.z.string(),
    pluginRoute: zod_1.z.string(),
    credentialForm: jsonForm_1.JsonFormSchema,
    schedulerSetup: zod_1.z.boolean(),
    defaultTime: zod_1.z.string().default("* * * * *"),
    lambdaARN: zod_1.z.string(),
    tag: zod_1.z.object({
        token: zod_1.z.array(token_1.tokenTypesSchema),
        category: zod_1.z.array(zod_1.z.object({
            country: BusinessMisc.CountrySchema,
            industry: zod_1.z.array(zod_1.z.object({
                type: BusinessMisc.IndustryTypeSchema,
                subIndustry: zod_1.z.array(zod_1.z.union([BusinessMisc.AnimalsSubIndustrySchema, BusinessMisc.PlantsSubIndustrySchema, BusinessMisc.ProductsSubIndustrySchema])).optional(),
            }))
        }))
    }),
    reports: zod_1.z.array(exports.PluginReportSchema).optional(),
    userId: zod_1.z.string(),
    version: zod_1.z.number().default(0),
    createdAt: zod_1.z.date()
});
//byservice
exports.ServicePluginSchema = exports.PluginGeneralSchema.merge(zod_1.z.object({
    credentialType: zod_1.z.literal(exports.CredentialTypeSchema.enum.byservice),
    keyId: zod_1.z.string(),
}));
//bybusiness
exports.BusinessPluginSchema = exports.PluginGeneralSchema.merge(zod_1.z.object({
    credentialType: zod_1.z.literal(exports.CredentialTypeSchema.enum.bybusiness),
}));
exports.PluginSchema = zod_1.z.union([exports.ServicePluginSchema, exports.BusinessPluginSchema]);
